<template>
    <div class="text-sm font-medium text-center text-[var(--medium-gray)]">
        <ul class="flex flex-wrap -mb-px items-center border-b border-[var(--light-gray)]">
            <li class="lg:mr-2 mt-1" v-for="code in options">
                <button
                    class="inline-block lg:px-4 py-4 px-2 border-b-2 rounded-t-md hover:text-[var(--medium-gray)] hover:border-[var(--primary-blue)] hover:bg-[var(--hover-gray)]"
                    :class="{ 'text-[var(--primary-blue)]': tab === code, 'border-[var(--primary-blue)]': tab === code, 'border-[var(--background)]': tab !== code }"
                    @click="click(code)">
                    {{ code }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { type PropType } from 'vue';

export default {
    props: {
        options: {
            type: Array as PropType<string[]>,
            required: true,
        },
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            tab: this.modelValue,
        };
    },
    watch: {
        modelValue(newValue) {
            this.tab = newValue;
        }
    },
    methods: {
        click(v: string) {
            this.tab = v;

            this.$emit('update:modelValue', this.tab);
        },
    },
};
</script>